<button
  class="app-btn"
  [attr.type]="type"
  [ngClass]="[
    'app-btn-' + variant,
    'app-btn-' + color,
    'app-btn-' + size,
    fullWidth ? 'app-btn-fullWidth' : '',
    buttonClass
  ]"
  (click)="handleButtonClick($event)"
  [disabled]="!!disabled || isLoading"
>
  <!-- <div *ngIf="isLoading" class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div> -->

  <div *ngIf="isLoading" class="circular-loader"></div>

  <!-- <img *ngIf="isLoading" class="app-loading-gif" src="./assets/loading.gif"> -->

  <ng-content></ng-content>
</button>